import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { GfTranslateService } from '../../../../services/core.translate.service';

@Injectable()
export class ProjectAdminChecksHelper {

  constructor(private translateService: GfTranslateService) {}

  getSortFields(): any {
    return {
      createDate: this.translateService.translate('Report Date'),
      id: this.translateService.translate('Report ID'),
      name: this.translateService.translate('Report Title')
    };
  }

  getAnyFilterObj(): any {
    return { id: '', label: this.translateService.translate('Any'), defaultSelected: true };
  }

  getCustomFilterObj(): any {
    return { id: null, label: this.translateService.translate('Custom'), defaultSelected: false };
  }

  getDateRangeElements(): any[] {
    return [
      this.getAnyFilterObj(),
      { id: '-7 days', label: this.translateService.translate('This Week') },
      { id: '-15 days', label: this.translateService.translate('Last 15 days') },
      { id: '-30 days', label: this.translateService.translate('Last 30 days') },
      { id: '-60 days', label: this.translateService.translate('Last 60 days') },
      { id: '-90 days', label: this.translateService.translate('Last 90 days') },
      { id: '-365 days', label: this.translateService.translate('Last year') }
    ];
  }

  getBaseFilters(): any[] {
    const any = this.getAnyFilterObj();
    return [
      {
        alias: 'since',
        fieldName: this.translateService.translate('Start Date'),
        value: '',
        fieldType: 9,
        isExtraField: false
      },
      {
        alias: 'before',
        fieldName: this.translateService.translate('End Date'),
        value: '',
        fieldType: 9,
        isExtraField: false
      },
      {
        alias: 'range',
        fieldName: this.translateService.translate('Date Range'),
        value: any,
        fieldType: 1,
        isExtraField: false,
        fieldElements: this.getDateRangeElements()
      }
    ];
  }

  getSelectedElement(filter: any, stateParams: any): any {
    const val = _.get(stateParams, filter.alias, false) || '';
    let elem = _.find(filter.fieldElements, { id: val });
    if (!elem) {
      elem = _.find(filter.fieldElements, { defaultSelected: true });
    }
    return elem;
  }

  setFiltersFromStateParams(filters: any, stateParams: any): any {
    return _.map(filters, (f: any) => {
      switch (f.fieldType) {
        case 1:
          f.value = this.getSelectedElement(f, stateParams);
          break;
        default:
          f.value = _.get(stateParams, f.alias, '');
          break;
      }
      return f;
    });
  }
}
